/**
 * @file 操作担当者情報モーダル管理
 */

'use strict';

/**
 * @classname OperatorDetailModal
 * @classdesc 操作担当者情報モーダル管理
 */
export default class OperatorDetailModal {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log(`OperatorDetailModal.constructor`);
		this._$e = $e;
		$e.on('click', () => this.onClick());
	}

	/**
	 * clickのコールバック
	 *
	 * @memberof BtnInvoice
	 * @return undefined
	 */
	onClick() {
		console.log(`OperatorDetailModal.onClick`);
		const name = this._$e.text();
		const title = this._$e.attr('data-title');
		const tel = this._$e.attr('data-tel');
		const email = this._$e.attr('data-email');
		const $modal = $('#modal-operator-detail');
		console.log($modal.find('.operator-detail-name'));
		$modal.find('.operator-detail-name').text(name);
		$modal.find('.operator-detail-title').text(title);
		$modal.find('.operator-detail-tel').text(tel);
		$modal.find('.operator-detail-email').text(email);
	};
}
